import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AddressService } from '@src/app/modules/address/address.service';
import { CommonService } from '@src/app/services/common.service';
import { TelegramService } from '@src/app/services/telegram.service';
import { UserService } from '@src/app/services/user.service';
import { WalletStatusService } from '@src/app/services/wallet-status.service';
import { SharedModule } from '@src/app/shared/shared.module';
import { AddressNftHoldingV2 } from '@src/app/shared/types/address.type';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { CollectionHoldingsComponent } from '../collection-holdings/collection-holdings.component';

@Component({
    selector: 'app-address-nfts',
    standalone: true,
    imports: [CommonModule, SharedModule, CollectionHoldingsComponent, NzSkeletonModule],
    templateUrl: './address-nfts.component.html',
    styleUrls: ['./address-nfts.component.less'],
})
export class AddressNftsComponent implements OnInit {
    @Input() walletAddress: string;
    @Input() pageType: 'address' | 'profile' = 'address';

    realWalletAddress: string;

    walletNftHoldings: AddressNftHoldingV2[];

    totalNFTCount = 0;

    constructor(
        private addressService: AddressService,
        private walletStatusService: WalletStatusService,
        public tgService: TelegramService,
        public commonService: CommonService,
        public userService: UserService
    ) {}

    ngOnInit() {
        this.realWalletAddress = this.walletAddress || this.walletStatusService.walletAddress;

        if (this.walletStatusService.isWalletConnected) {
            this.addressService.getNftHoldingsV2(this.realWalletAddress).then(data => {
                this.walletNftHoldings = data.holdings.sort((a, b) => b.nft_count - a.nft_count);
                this.totalNFTCount = this.walletNftHoldings.reduce((acc, curr) => acc + curr.nft_count, 0);
            });
        }
    }

    errorHandler(e: any) {
        e.target.src = '/assets/imgs/fallback.png';
    }

    getTokenImg(collection: AddressNftHoldingV2, tokenId: number | string) {
        return this.commonService.tokenImage(collection.chain_name, collection.token_address, tokenId);
    }
}
